"use client";
import { Stack, Typography, Button, Box } from "@mui/material";
import { HeroBanner } from "../hero_banner";
import Image from "next/image";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { useRouter } from "next/navigation";
import { TitleGradientText } from "../title_gradient_text";

export function HeroFooter() {
  const router = useRouter();

  const handleContactUsClick = () => {
    router.push("/contact-us");
  };

  const handleProductsClick = () => {
    router.push("/products");
  };

  return (
    <HeroBanner background="/images/home/hero_footer.jpg">
      <Stack
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
        gap={12}
      >
        <Stack width="100%" alignItems="center" justifyContent="center">
          <Typography
            variant="h3"
            fontWeight="500"
            textAlign="center"
            sx={{
              fontSize: {
                xs: "32px",
                md: "48px",
              },
            }}
          >
            สนใจซื้อผลิตภัณฑ์ของ{" "}
            <TitleGradientText
              variant="h3"
              component="span"
              fontWeight="500"
              textAlign="center"
              display={{
                xs: "none",
                md: "block",
              }}
            >
              “เชฟไพรฑูรย์”
            </TitleGradientText>
          </Typography>
          <TitleGradientText
            variant="h5"
            component="span"
            fontWeight="500"
            textAlign="center"
            display={{
              xs: "block",
              md: "none",
            }}
          >
            “เชฟไพรฑูรย์”
          </TitleGradientText>
          <Typography variant="body1" fontWeight="400" textAlign="center">
            เราบริการครอบคลุมทั้ง B2B และ B2C
          </Typography>
        </Stack>
        <Stack
          direction="row"
          width="100%"
          alignItems="center"
          justifyContent="center"
          gap={3}
        >
          <Button variant="contained" onClick={handleProductsClick}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography variant="button" color="textPrimary">
                ผลิตภัณฑ์ทั้งหมด
              </Typography>
              <ArrowForwardRoundedIcon
                style={{
                  color: "#fff",
                }}
              />
            </Stack>
          </Button>
          <Button
            variant="contained"
            onClick={handleContactUsClick}
            color="secondary"
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography variant="button" color="textPrimary">
                สอบถามเพิ่มเติม
              </Typography>
              <ArrowForwardRoundedIcon
                style={{
                  color: "#fff",
                }}
              />
            </Stack>
          </Button>
        </Stack>
      </Stack>
    </HeroBanner>
  );
}
